import styled from 'styled-components'
// import noContent from 'assets/icons/no-content.png'
import { useTranslation } from 'react-i18next'

export default function NoContent({ message }: { message?: string }) {
  const { t } = useTranslation()
  return (
    <NoContentWrapper>
      {/* <NoContentImage src={noContent} alt="Content Not Found" /> */}
      <NotFoundMessage>{message || t('most-used-words.not-found')}</NotFoundMessage>
    </NoContentWrapper>
  )
}

const NoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding: 1rem;

  .p-progress-spinner {
    width: 120px;
  }
`

const NotFoundMessage = styled.p`
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.8px;
  margin: 0.5rem 0.5rem;
`

// const NoContentImage = styled.img`
//   width: 70px;
// `
